import { emailSchema, passwordSchema } from "../../../shared/lib/schemas/common.schema";
import { z } from "zod";

export const loginFormSchema = z.object({
    email: emailSchema,
    password: passwordSchema.optional(),
    code: z
        .string()
        .optional()
        .refine((val) => !val || val.length === 6, "Enter the 6-digit code"),
})

export type LoginFormType = z.infer<typeof loginFormSchema>